import { WEATHER_API } from '../environment.constants'

export class WeatherAPIURL {
    public static weather: string =  WEATHER_API + "/weather";
    public static kp: string =  WeatherAPIURL.weather + "/kp";
    public static satellite: string =  WeatherAPIURL.weather + "/satellite";
    public static dust: string =  WeatherAPIURL.weather + "/dust";
}